import { GiftCard } from './gift-card'
import { Injectable } from '@angular/core'

@Injectable()
export class GiftCardSerializer {
  fromJson(json: any): GiftCard {
    const giftCard = {
      ...json
    }

    return giftCard
  }

  toJson(giftCard: GiftCard): any {
    return {
      ...giftCard
    }
  }
}
